// extracted by mini-css-extract-plugin
export var root = "F_wq";
export var wrapper = "F_wr";
export var image = "F_ws d_w d_y d_W";
export var imageWithHeight = "F_wt";
export var crop = "F_wv";
export var round = "F_ww";
export var fixedHeight = "F_wx";